import React from "react";
import { Grid, Typography, Button, Container } from "@mui/material";
import OakImage from "../../assets/OAK-Color-01 1-1.png";
import InfoImage from "../../assets/Info-13.svg";
import LaptopImage from "../../assets/Group 174.png";
import "./index.css";
export default function index() {
  return (
    <>
      <Container className="section-3-max-container">
        <Grid container className="main-container-section-3">
          <Grid item className="main-img-div-3">
            <img src={LaptopImage} className="main-image-3" />
          </Grid>
          <Grid item className="main-text-div-22">
            <Typography className="main-text-1">
              Terra Treasury
              <Typography className="main-text-1">
                offers a genius
                <Typography className="main-text-2">WebApp</Typography>
              </Typography>
            </Typography>
            <Grid>
              <Typography className="section-text">
                Built simple and secure - Enjoy the most valuable
                <Typography className="section-text"></Typography>
                ecosystem in the world.
              </Typography>
              <Grid className="section3-oak">
                <Typography className="section3-text">
                  Audit in Progress by:
                </Typography>
                <img src={OakImage} className="oak-image" />
              </Grid>
            </Grid>
            <Grid className="main-buttons-div">
              <Button className="main-button-section">
                <Typography className="main-button-section">
                  Learn More
                </Typography>
                <img src={InfoImage} />
              </Button>
              <Button className="header-button">
                {/* <img src={ButtonImg} /> */}
                <Typography className="header-button-text">WebApp</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
